import React, { useEffect, useRef, useState } from "react";
import { isChildElement } from "../../utils/isChildElement";
import './DropDown.css';

interface IDropDownProps{
    values: Array<string | number>;
    selectedIndex: number;
    onSelect: (index: number)=>void;
    maxHeight?: number;
    width?: number;
    className?: string;
}

export const DropDown = ({values, selectedIndex, onSelect, maxHeight, width, className}: IDropDownProps)=>{
    const [isOpened, setOpened] = useState(false);
    const dropDownRef = useRef<HTMLDivElement>(null);

    const handleSelect = (index: number) => ()=>{
        setOpened(false);
        onSelect(index);
    }

    useEffect(()=>{
        const windowHandler = (e: MouseEvent)=>{
            if (!isChildElement(e.target as HTMLElement, dropDownRef.current)){
                setOpened(false);
            }
        }
        window.addEventListener('click', windowHandler);
        return ()=>{
            window.removeEventListener('click', windowHandler);
        }
    }, []);

    return <div ref={dropDownRef} className={`commonDropDown ${isOpened ? 'commonDropDown--opened': '' } ${className || ''}`} style={{width: width + 'px'}}>
        <div className="commonDropDown_wrap">
            <div className="commonDropDown_header" onClick={()=>setOpened((last)=>!last)}>
                <div className="commonDropDown_value">
                    {values[selectedIndex] || ''}
                </div>
                <div className="commonDropDown_arrow"></div>
            </div>
            <div className="commonDropDown_list_wrap">
                <div className={`commonDropDown_list ${maxHeight ? 'scroll commonDropDown_list--scroll' : ''}`} style={{maxHeight: maxHeight ? maxHeight+'px' : null}}>
                    {values.map((it, i)=>{
                        return <div key={`dropdown-item-${i}`} className="commonDropDown_item" onClick={handleSelect(i)}>{it}</div>
                    })}
                </div>
            </div>
        </div>
    </div>
}